import { useState } from "react";
import { ArrowRight, Play } from "lucide-react";

/**
 * Section "Onde a operação acontece" — vídeo da operação Allu (YouTube) +
 * galeria de fotos.
 *
 * Vídeo: thumbnail click-to-play (lazy iframe).
 * Fotos: /public/selecao/escritorio/foto-1.jpg ... foto-6.jpg
 */

const VIDEO_ID = "lRz43alhxio";

const STATS = [
  { value: "10 anos", label: "de operação" },
  { value: "+60 mil", label: "clientes atendidos" },
  { value: "R$ 650M+", label: "captados" },
  { value: "100%", label: "adimplência" },
];

export const SelecaoEscritorio = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="quem-e-a-allu" className="bg-white scroll-mt-24">
      <div className="container-wide py-12 sm:py-20">
        <div className="max-w-3xl mx-auto text-center mb-6 sm:mb-8">
          <div className="text-[11px] font-semibold tracking-[0.14em] uppercase text-zinc-500">
            Quem é a Allu
          </div>
          <h2
            className="mt-3 text-2xl sm:text-3xl md:text-4xl font-bold text-[#112711] tracking-tight leading-[1.1]"
            style={{ letterSpacing: "-0.02em" }}
          >
            Fundada em 2016, a Allu é a terceira maior empresa do mundo em seu
            segmento.
          </h2>
        </div>

        {/* Stats acima do vídeo — 2x2 mobile, 1x4 desktop, tudo centralizado */}
        <dl className="max-w-3xl mx-auto mb-6 sm:mb-8 grid grid-cols-2 md:grid-cols-4 gap-y-5 gap-x-4 md:gap-x-6 md:divide-x md:divide-zinc-200">
          {STATS.map((s, i) => (
            <div
              key={i}
              className={`text-center ${i > 0 ? "md:pl-4 lg:pl-6" : ""}`}
            >
              <dt className="text-xl sm:text-2xl font-normal text-[#112711] tracking-tight tabular-nums leading-none">
                {s.value}
              </dt>
              <dd className="mt-1.5 text-[10px] sm:text-[11px] uppercase tracking-wider text-zinc-500 leading-snug">
                {s.label}
              </dd>
            </div>
          ))}
        </dl>

        {/* Vídeo — thumbnail click-to-play (não pré-carrega iframe) */}
        <div className="relative rounded-2xl overflow-hidden bg-zinc-900 aspect-video ring-1 ring-zinc-200 mb-6 sm:mb-8 max-w-3xl mx-auto">
          {playing ? (
            <iframe
              src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0&modestbranding=1`}
              className="w-full h-full border-0"
              title="Allu — Por dentro da operação"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              className="group absolute inset-0 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#112711] focus-visible:ring-offset-2"
              aria-label="Reproduzir vídeo: Veja nossa estrutura — 56 segundos"
            >
              <img
                src={`https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                alt=""
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover"
                onError={(e) => {
                  // fallback se maxresdefault não existir (uploads antigos)
                  (e.currentTarget as HTMLImageElement).src = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;
                }}
              />
              <div
                aria-hidden="true"
                className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors"
              />

              {/* Play + CTA text */}
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 sm:gap-4 px-4">
                <div
                  className="w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center transition-all duration-200 group-hover:scale-110"
                  style={{ backgroundColor: "rgba(17, 39, 17, 0.9)" }}
                >
                  <Play
                    className="w-6 h-6 sm:w-7 sm:h-7 text-white fill-white ml-1"
                    aria-hidden="true"
                  />
                </div>
                <span className="text-white font-semibold text-base sm:text-lg tracking-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
                  Veja nossa estrutura
                </span>
              </div>

              {/* Duration badge — estilo YouTube */}
              <div className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4">
                <span className="inline-block bg-black/80 text-white text-[11px] sm:text-xs font-medium tabular-nums px-1.5 py-0.5 rounded">
                  0:56
                </span>
              </div>
            </button>
          )}
        </div>

        {/* CTA — abaixo do vídeo */}
        <div className="mt-8 sm:mt-10 flex justify-center">
          <a
            href="#form"
            className="inline-flex items-center gap-2 rounded-full font-semibold text-sm h-12 px-7 bg-[#112711] hover:bg-[#1F4A33] text-white transition-all hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#112711]"
          >
            Reservar minha vaga
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};
